import { ObjectStrings } from '../types/commonTypes';

export const MESSAGE_ID_NAME = 'chat-message-';
export const TYPING_MESSAGE_ID = 'typing-message';
export const TICKET_MESSAGE_ID = 'ticket-message';
export const TICKET_CREATED_MESSAGE_ID = 'ticket-created-message';

export const FILE_ICON_TYPES: ObjectStrings = {
  pdf: 'colored--32--pdf',
};
